// AttendeeAvatar — MD3 Avatar с status indicator (online/offline).
import { Avatar, Box, Tooltip } from '@mui/material';
import type { EventAttendee, AttendeeStatus } from '@/api/calendar';

const STATUS_COLORS: Record<AttendeeStatus, string> = {
  ACCEPTED: '#10B981', // зелёный
  PENDING: '#F59E0B', // оранжевый
  DECLINED: '#EF4444', // красный
  TENTATIVE: '#6B7280', // серый
};

interface AttendeeAvatarProps {
  /** DTO участника события. */
  attendee: EventAttendee;
  /** Размер аватара (по умолчанию 32). */
  size?: number;
}

/** MD3 Avatar участника события с цветным индикатором статуса. */
export function AttendeeAvatar({ attendee, size = 32 }: AttendeeAvatarProps): JSX.Element {
  const initials = attendee.userId.slice(0, 2).toUpperCase();
  return (
    <Tooltip title={`User ${attendee.userId} · ${attendee.status}`}>
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <Avatar
          sx={{ width: size, height: size, fontSize: size * 0.4, bgcolor: 'grey.500' }}
        >
          {initials}
        </Avatar>
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            right: 0,
            width: size * 0.3,
            height: size * 0.3,
            borderRadius: '50%',
            bgcolor: STATUS_COLORS[attendee.status],
            border: 1.5,
            borderColor: 'background.paper',
          }}
        />
      </Box>
    </Tooltip>
  );
}
